import { Popover, message } from "antd";
import { cn } from "../../../../../helper/cn";
import { Base64 } from "js-base64";
import React, { useEffect, useMemo, useState, useContext, useCallback, useRef } from "react";
import Group from "../../../../../assets/customSVG/Group";
import Tag from "../../../../../assets/customSVG/Tag";
import { ICONS } from "../../../../../assets/icons";
import { ICONSS } from "../../../../../assets/icons/index1";
import { useAspSelector } from "../../../../../test/jest-redux-hooks";
import { crmFileStatus, crmFileStatusUpdate, crmBulkTagAssign, AudienceSetSingle, AudienceSetSetVersion, AudienceSetUpdate } from '../../../api/Api';
import EditAudienceModal from '../../audience/EditAudienceModal';
import { crmFontColor } from "../../../constants";
import Tags from "../../main/contact/Tags";
import ToastMain from "../../../../../components/commonComponents/toast/ToastMain";
import { useSelector } from "react-redux";
import AudienceVersionsDropdown from "../audience/AudienceVersionsDropdown";
import NotificationContext from "../../../../../providers/NotificationProvider";
import { showErrorToast, showSuccessToast } from "../../../../../components/commonComponents/gxAntdToast/toastUtils";
import { useFunction } from "../../../../../hooks/useFeatureGating";
import { FUNCTIONS } from "../../../../../constant/featureSlugs";
import Tooltip  from "../../../../../components/commonComponents/tooltip";

function buildBulkActionPayload({
  brand_id,
  select_all,
  selectedIds = [],
  deselectedIds = [],
  tag_ids,
  filters,
  search,
  activeFilter,
  tag_action,
}) {
  const payload = {
    brand_id,
    tag_action,
    select_all,
    contact_person_ids: select_all ? deselectedIds : selectedIds,
    tag_ids,
  };
  if (filters) payload.filters = filters;
  if (search) payload.search = search;
  if (activeFilter?.tag) payload.tag_id = activeFilter?.id;
  if (activeFilter?.user_name) payload.user_id = activeFilter?.id;
  if (activeFilter?.name) payload.contact_origin = activeFilter?.name;
  return payload;
}

const Header = ({
  count,
  count1,
  crmLists,
  viewLists,
  viewListsShow,
  viewCount,
  selectedItems = [],
  selectAll = false,
  totalSelectedCount = 0,
  search = "",
  activeFilter,
  setActiveFilter,
  onAudienceUpdated,
}) => {
  const { filters } = useSelector((store) => store.crm);
  const { currentBrand } = useSelector((store) => store.app);
  const selectedTags = useMemo(() => {
    return [];
  }, []);

  // useState for toast
  const [toastState, setToastState] = useState({
    show: false,
    message: "",
    type: "Success"
  });

  // Handle toast close
  const handleToastClose = () => {
    setToastState(prev => ({ ...prev, show: false }));
  };

  // open action/close action columns
  const [isTagsDropdownOpen, setIsTagsDropdownOpen] = useState(false);

  const [progressCount, setProgressCount] = useState([]);
  const [isVisible, setIsVisible] = useState(true);

  const notification = useContext(NotificationContext);
  const bulkUploadIntervalRef = useRef(null);
  const bulkUploadTimeoutRef = useRef(null);

  const stopBulkUploadPolling = useCallback(() => {
    if (bulkUploadIntervalRef.current) {
      clearInterval(bulkUploadIntervalRef.current);
      bulkUploadIntervalRef.current = null;
    }
    if (bulkUploadTimeoutRef.current) {
      clearTimeout(bulkUploadTimeoutRef.current);
      bulkUploadTimeoutRef.current = null;
    }
  }, []);

  const fetchProgress = useCallback(() => {
    if (!currentBrand?.brand_id) {
      stopBulkUploadPolling();
      return;
    }

    crmFileStatus(currentBrand?.brand_id)
      .then((res) => {
        if (res?.status === 200) {
          const uploads = res?.data?.crm_bulk_uploads || [];
          const data = uploads?.[0];

          setProgressCount(data || {});

          if (uploads.length > 0) {
            setIsVisible(true);
          } else {
            setIsVisible(false);
            stopBulkUploadPolling();
            return;
          }

          const payLoad = {
            crm_bulk_upload_id: data?.crm_bulk_upload_id,
          };

          if (data?.status === 10) {
            if (bulkUploadTimeoutRef.current) {
              clearTimeout(bulkUploadTimeoutRef.current);
            }

            bulkUploadTimeoutRef.current = setTimeout(() => {
              crmFileStatusUpdate(currentBrand?.brand_id, payLoad).then(
                (res) => {
                  if (res?.status === 200) {
                    setIsVisible(false);
                  }
                }
              );
            }, 100000);
          }
        } else {
          stopBulkUploadPolling();
        }
      })
      .catch(() => {
        stopBulkUploadPolling();
      });
  }, [currentBrand?.brand_id, stopBulkUploadPolling]);

  const startBulkUploadPolling = useCallback(() => {
    if (!currentBrand?.brand_id) {
      stopBulkUploadPolling();
      return;
    }

    stopBulkUploadPolling();
    fetchProgress();
    bulkUploadIntervalRef.current = setInterval(fetchProgress, 5000);
  }, [currentBrand?.brand_id, fetchProgress, stopBulkUploadPolling]);

  useEffect(() => {
    startBulkUploadPolling();

    return () => {
      stopBulkUploadPolling();
    };
  }, [startBulkUploadPolling, stopBulkUploadPolling]);

  useEffect(() => {
    const handleBulkUploadStart = () => startBulkUploadPolling();
    window.addEventListener("crm:bulk-upload-start", handleBulkUploadStart);

    return () => {
      window.removeEventListener(
        "crm:bulk-upload-start",
        handleBulkUploadStart
      );
    };
  }, [startBulkUploadPolling]);

  const toggleTagsDropdown = () => {
    setIsTagsDropdownOpen(!isTagsDropdownOpen);
  };


  async function handleBulkTagAssign(selectedTagIds, tag_action = 'assign') {
    try {
      const currentBrandId = currentBrand?.brand_id;
      const selectedIds = selectedItems.filter(i => i.selected).map(i => i.id);
      const deselectedIds = selectedItems.filter(i => !i.selected).map(i => i.id);
      const payload = buildBulkActionPayload({
        brand_id: currentBrandId,
        select_all: selectAll,
        selectedIds,
        deselectedIds,
        tag_ids: selectedTagIds,
        filters: Object.keys(filters)?.length > 0 ? Base64.encode(JSON.stringify(filters)) : undefined,
        search,
        activeFilter,
        tag_action,
      });
      const response = await crmBulkTagAssign(payload);
      
      // Reset any existing toast first
      setToastState({ show: false, message: "", type: "Success" });
      
      // Set new toast after a brief delay
      setTimeout(() => {
        if (response?.status === 200) {
          showSuccessToast(notification, 'Tags assigned successfully!');
        } else {
          showErrorToast(notification, 'Failed to assign tags');
        }
      }, 100);

    } catch (error) {
      console.error("Error assigning tags:", error);
      showErrorToast(notification, 'Error assigning tags');
    }
  }

  const isAudienceSet = activeFilter?.type === 'audience_set';
  const [versions, setVersions] = useState([]);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [versionsLoading, setVersionsLoading] = useState(false);

  const { isEnabled: canUseVersioning } = useFunction(FUNCTIONS.CRM_VERSIONING);

  const [previewingVersion, setPreviewingVersion] = useState(null);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);

  const handleVersionSelect = async (version) => {
    try {
      setIsPreviewLoading(true);
      // Update the active filter with the selected version's data
      const updatedFilter = {
        ...activeFilter,
        filters: version.selection_criteria || [],
        added_contact_person_ids: version.added_contact_person_ids || [],
        removed_contact_person_ids: version.removed_contact_person_ids || [],
        version: version.version,
        isPreview: false
      };
      
      // Update the active filter in the parent component
      setActiveFilter(updatedFilter);
      setPreviewingVersion(null);
      
    } catch (error) {
      console.error('Error handling version change:', error);
      showErrorToast(notification, 'Failed to load versions');
    } finally {
      setIsPreviewLoading(false);
    }
  };

  const handleVersionChange = async (version) => {
    // This is called when a version is selected from the dropdown
    // We'll use handleVersionPreview for preview functionality
    await handleVersionSelect(version);
  };

  const handleVersionPreview = async (version) => {
    if (!version) {
      // Exit preview mode - reload the current version data
      try {
        setIsPreviewLoading(true);
        setPreviewingVersion(null);
        
        // Find the current version in the versions list
        const currentVersion = versions.find(v => v.is_current);
        if (currentVersion) {
          // Create a new filter with the current version's data
          const currentFilter = {
            ...activeFilter,
            filters: currentVersion.selection_criteria || [],
            added_contact_person_ids: currentVersion.added_contact_person_ids || [],
            removed_contact_person_ids: currentVersion.removed_contact_person_ids || [],
            version: currentVersion.version,
            isPreview: false
          };
          
          // Update the active filter to trigger a reload of the member list
          setActiveFilter(currentFilter);
        }
      } catch (error) {
        console.error('Error exiting preview mode:', error);
        showErrorToast(notification, 'Failed to load current version data');
      } finally {
        setIsPreviewLoading(false);
      }
      return;
    }

    try {
      setIsPreviewLoading(true);
      setPreviewingVersion(version);
      
      // Update the active filter with the preview version's data
      const previewFilter = {
        ...activeFilter,
        filters: version.selection_criteria || [],
        added_contact_person_ids: version.added_contact_person_ids || [],
        removed_contact_person_ids: version.removed_contact_person_ids || [],
        version: version.version,
        isPreview: true
      };
      
      // Update the active filter in the parent component
      setActiveFilter(previewFilter);
    } catch (error) {
      console.error('Error previewing version:', error);
      showErrorToast(notification, 'Failed to preview version');
    } finally {
      setIsPreviewLoading(false);
    }
  };

  const handleEditClick = () => {
    setIsEditModalVisible(true);
  };

  const handleEditSuccess = async () => {
    setIsEditModalVisible(false);
    // Refresh the audience set data by calling the parent's update callback
    if (onAudienceUpdated) {
      await onAudienceUpdated();
    }
  };

  return (
    <div className="flex justify-between gap-2 bg-white px-[2vw] py-[1.5vh] text-[1.7vh] align-center relative">
      {toastState.show && (
        <div className="fixed top-4 right-4 z-[9999]">
          <ToastMain
            show={toastState.show}
            message={toastState.message}
            type={toastState.type}
            onClose={() => setToastState(prev => ({ ...prev, show: false }))}
            handleClick={handleToastClose}
          />
        </div>
      )}
      
      <div className="flex items-center gap-2 justify-between">
        <p className="font-semibold">
          {crmLists?.length > 0 && !viewListsShow && <>{`${count} contacts`}</>}
          {viewListsShow && viewLists?.length > 0 && <>{`${viewCount} contacts`}</>}
        </p>

        {isAudienceSet && (
        <div className="flex items-center gap-2">
          <button 
            className="flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-gray-700 hover:bg-gray-100 rounded-md border border-gray-200"
            onClick={handleEditClick}
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
            </svg>
            Edit
          </button>
          <Tooltip
            content={!canUseVersioning ? "This feature is not available in your plan. Upgrade to access." : ""}
          >
            <AudienceVersionsDropdown
              audienceSetId={activeFilter?.id}
              onVersionSelect={handleVersionSelect}
              onVersionChange={handleVersionChange}
              currentVersion={activeFilter?.version}
              onVersionPreview={handleVersionPreview}
              isPreviewLoading={isPreviewLoading}
              previewingVersion={previewingVersion}
              disabled={!canUseVersioning}
            >
              <button 
                className={cn(
                  "flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-gray-700 rounded-md border border-gray-200 transition-all",
                  !canUseVersioning ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-100"
                )}
                disabled={!canUseVersioning}
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                Version History
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-3.5 w-3.5 ml-1 text-gray-400"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </button>
            </AudienceVersionsDropdown>
          </Tooltip>
        </div>
      )}
      </div>
      {/* Edit Audience Modal */}
      {isAudienceSet && (
        <EditAudienceModal
          key={isEditModalVisible}
          visible={isEditModalVisible}
          onClose={() => setIsEditModalVisible(false)}
          onSuccess={handleEditSuccess}
          audienceData={{
            id: activeFilter?.id,
            name: activeFilter?.name || '',
            description: activeFilter?.description || '',
            filters: activeFilter?.filters || [],
            added_contact_person_ids: activeFilter?.added_contact_person_ids || [],
            removed_contact_person_ids: activeFilter?.removed_contact_person_ids || []
          }}
          brandId={currentBrand?.brand_id}
        />
      )}

      {/* hidden header column */}
      {isVisible &&
        (
          <div className="bg-[#F4F6F8] p-5 b-radius-6 pointer w-fit">
            {progressCount?.status !== 10 ? (
              <Popover
                open={isTagsDropdownOpen}
                onOpenChange={(open) => setIsTagsDropdownOpen(open)}
                content={
                  <div className="p-10">
                    <span>{progressCount?.file_name}.xlsx uploading</span>
                    <div className="flex-row align-center gap-5 pt-10">
                      <progress
                        value={progressCount?.percentage}
                        max="100"
                        className="custom-progress-crm"
                      />
                      <span className="font15px-400 text-[var(--new-primary)]">
                        {progressCount?.percentage || 0}%
                      </span>
                    </div>
                  </div>
                }
                trigger="click"
                arrow={false}
                placement="bottom"
                overlayInnerStyle={{ marginTop: "5px" }}
                onClick={toggleTagsDropdown}
              >
                <div className="flex-row align-center gap-2.5">
                  <img
                    src={ICONSS?.UploadingIcon}
                    alt="UploadingIcon"
                    className="pl-5"
                  />
                  <span className="font14px-500 text-[var(--new-primary)]">
                    {progressCount?.percentage || 0}%
                    <span className="pl-10 font14px-600 text-[var(--font-600)]">
                      Contacts Uploading
                    </span>
                  </span>
                  <img
                    src={ICONS?.chevronDownCarousel}
                    alt="chevronDownCarousel"
                    className={`${isTagsDropdownOpen ? "rotate-180" : ""}`}
                  />
                </div>
              </Popover>
            ) : (
              <div className="flex-row align-center font14px-600 text-[var(--new-primary)] gap-2">
                <img src={ICONSS?.successfulIcon} alt="successfulIcon" />
                <span>Contacts Uploaded Successfully</span>
              </div>
            )}
          </div>
        )
      }
    </div>
  );
};

export default Header;
